import {apiAction} from 'apa/actions'
import * as types from 'customers/actions/types'


export const add = (note, callback) => dispatch =>
  dispatch(apiAction({
    url: '/api/notes/',
    method: 'POST',
    data: note,
    onSuccess: (note) => {
      callback(note)
      return {
        type: types.NOTE_CREATE,
      }
    }
  }))

export const remove = (note) => (dispatch, getState) =>
  dispatch(apiAction({
    url: `/api/notes/${note.id}/`,
    method: 'DELETE',
    onSuccess: (note) => {
      const customer = getState().customers.customer
      const noteIndex = customer.contacts.findIndex(
        (item) => item.id === note.id
      )
      customer.notes.splice(noteIndex, 1)
      return {
        type: types.DELETE_NOTE,
        customer: customer
      }
    }
  }))